import React from 'react';

import GalleryPageLayout from './GalleryPageLayout';
import GalleryCoverflowCarousel from './GalleryCoverflowCarousel';
import { AWARENESS_PHOTOS as PHOTOS } from './galleryRealData';

/* Awareness Campaigns — live gallery page on the 3D Coverflow design. */
const AwarenessCampaigns = () => (
    <GalleryPageLayout
        title="Awareness Campaigns"
        introImage={process.env.PUBLIC_URL + "/images/about-v2/awareness-campaigns.jpg"}
        introImageAlt="Life Saver Army volunteers at an awareness camp"
        introImagePlain
        galleryKicker="Photo gallery"
        galleryHeading="Moments From Our Campaigns"
        kicker="Stickers, street outreach and public campaigns"
        heading="Awareness Campaigns"
        lead="Reaching donors means being visible where people already are. Our campaigns turn a passing glance into a registered donor."
        metaTitle="Awareness Campaigns — Gallery | JJF India"
        metaDescription="Photo highlights from JJF India's awareness campaigns, presented in an immersive 3D coverflow gallery."
    >
        <GalleryCoverflowCarousel photos={PHOTOS} />
    </GalleryPageLayout>
);

export default AwarenessCampaigns;
